<template>
    <div
        v-if="result"
        class="privat-installments-range"
        @mouseup="handlerDragEnd"
    >
        <VueSlider
            v-if="result.payData"
            :modelValue="+result.payData.PARTS_COUNT"
            :interval="1"
            :min="start"
            :max="+result.payData.MAX_PARTS_COUNT"
            :marks="true"
            v-bind="sliderProps"
            @change="changeData"
        />
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import {  mapMutations, mapActions } from 'vuex';

export default {
    name: 'InstallmentsRange',
    props: ['result', 'start'],
    components: {
        VueSlider
    },
    data() {
        return {
            value: '0',
            sliderProps: {
                dotSize: [24, 24],
                dotOptions: {
                    tooltip: 'none',
                },
                railStyle: {
                    backgroundColor: 'var(--background-grey)',
                },
                processStyle: {
                    backgroundColor: 'var(--background-beige)',
                },
                stepStyle: {
                    height: '8px',
                    backgroundColor: 'var(--background-grey)',
                }
            }
        }
    },
    computed: {
        marks() {
            const { MAX_PARTS_COUNT } = this.result.payData
            const obj = { }
            const arr = [];
            // MAX_PARTS_COUNT / 100 = 1 %

            // 12 / 0.24
            for (let i = 2; i <= MAX_PARTS_COUNT; i++) {
                // obj[ Math.round(i / (MAX_PARTS_COUNT / 100)) ] = i;

                arr.push(i);
            }
            // console.log(arr);
            return arr;
        }
    },
    methods: {
        ...mapMutations({
            setRequestData: 'checkout/setRequestData'
        }),
        ...mapActions({
            setAjax: 'checkout/setAjax',
        }),
        setPartsCount(PARTS_COUNT) {
            // 'ORDER_PROP_29' - property PrivatBank in Bitrix, where you can find settings of the prop and choose correct ORDER_PROP_ID
            // https://sova2-3.bi3x.org/bitrix/admin/sale_order_props_edit.php?lang=ru&ID=29&filter=Y&set_filter=Y
            const partsCount = { PARTS_COUNT };
            this.setRequestData({ name : this.result.psOrderProp, value: JSON.stringify( partsCount ) });
        },
        changeData(PARTS_COUNT) {
            this.setPartsCount(PARTS_COUNT);
        },
        handlerDragEnd() {
            /** fix change after click on line **/
            setTimeout(this.setAjax, 4);
        },
    },
}
</script>

<style lang="scss" scoped>
.privat-installments-range{
    padding-bottom: 14px;
    margin-bottom: 40px;
    :deep(.vue-slider-dot){
        border: 5px solid var(--background-beige);
        border-radius: 50%;
    }
    :deep(.vue-slider-dot-handle){
        box-shadow: none;
    }
    :deep(.vue-slider-mark){
        height: 8px !important;
        top: 4px;
        transform: translate(-50%, 0);
        width: 2px !important;
    }
    :deep(.vue-slider-mark-step){
        border-radius: 0;
    }
    :deep(.vue-slider-mark-label){
        font-weight: 500;
        font-size: rem(14);
        line-height: 125%;
        color: var(--color-dark-grey);
        margin-top: 4px;
    }
}
</style>